import React, { useContext, useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    IconButton,
    FormControl,
    InputLabel,
} from "@mui/material";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from "formik";
import TableComponent from "../TableComponent";
/*
Propslar
props.data tablodaki verileri basmak için
props.yili
props.eglenceYeriAdi
props.gelirAciklamasi

*/
const EglenceVergisiTarifeleriPopUp = (props: any) => {
    const columns = [

        { header: "Yılı", field: "yili", className: "text-center" },
        { header: "Eğlence Yeri Adı", field: "eglenceYeriAdi", className: "text-center" },
        { header: "Gelir Açıklaması", field: "gelirAciklamasi", className: "text-center" },
    ];


    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };
    return (
        <Dialog
            sx={{
                '& .MuiDialog-paper': { // Dialog'un iç kağıdı üzerinde stil uygulama
                    m: "1rem", // margin değerini sıfırla
                    maxWidth: '100%', // Maksimum genişliği %100 yap, ekranı tam kaplasın
                    width: '100%', // Genişliği %100 yap
                    maxHeight: '100vh', // Maksimum yüksekliği viewport'un %100'ü yap
                }
            }}
            fullWidth={true}
            maxWidth="xl"

            open={props.openPopup}

            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <DialogTitle justifyContent={"space-between"} id="dialog-title">{"Eğlence Vergisi Tarifeleri"}
                <IconButton
                    aria-label="close"
                    onClick={() => props.openPopup()}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme: any) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton> </DialogTitle>
            <DialogContent className="p-1 p-sm-4">
                <Formik
                    initialValues={initialValues}
                    onSubmit={() => { }}>
                    <Form id="kayit-form" className="d-flex flex-column  justify-content-center p-2 ">
                        <div className="d-flex justify-content-between flex-column  w-100 gap-3  ml-2 mr-2">
                            <div className="d-flex gap-3 w-100 flex-column flex-md-row">
                                <div className="form-group w-100 align-self-center">
                                    <FormControl fullWidth size="small">
                                      
                                        <TextField label={"Yılı"} size="small" className="w-100" value={props.selectedData.yili} />
                                    </FormControl>
                                </div>
                                <div className="form-group w-100 align-self-center">
                                    <FormControl fullWidth size="small">
                                        <TextField label={"Eğlence Yeri Adı"} size="small" className="w-100" value={props.selectedData.eglenceYeriAdi} />
                                    </FormControl>
                                </div>
                                <div className="form-group w-100 align-self-center">
                                    <FormControl fullWidth size="small">
                                        <TextField label={"Gelir Açıklaması"} size="small" className="w-100" value={props.selectedData.gelirAciklamasi} />
                                    </FormControl>
                                </div>

                            </div>
                            {/* <SearchComponent
                            fetchData={fetchData}
                            setRecaptchaPassed={setRecaptchaPassed}
                            recaptchaError={recaptchaError}
                            onTemizle={handleTemizle}
                            setData={setData} />
                   */}
                        </div>
                    </Form>
                </Formik>
                <TableComponent columns={columns} data={props.data}  ></TableComponent>
            </DialogContent>

        </Dialog >
    );
};

export default EglenceVergisiTarifeleriPopUp;
